module.exports = __webpack_public_path__ + "static/media/bg_5.be29f1d1.jpg";